import * as Sentry from '@sentry/react';
import { ABORT_ERROR } from '../api/errors/errorTypes';

function sentryCaptureError(e) {
  if (e.type !== ABORT_ERROR) {
    Sentry.captureException(e);
  }
}

export default sentryCaptureError;
